export default "__VITE_ASSET__DZXWzfPp__"